import React from 'react';

function App() {
  return (
    <div className="App">
      <h1>Welcome to Museum Archive</h1>
    </div>
  );
}

export default App;